import { Controller, useFormContext } from "react-hook-form";
import dayjs from "dayjs";
import type { FC } from "react";
import type { AppDatePickerProps } from "../../AppDatePicker";
import { FormFieldWrapper } from "../FormFieldWrapper";
import { AppYearDatePicker } from "../../AppDatePicker";

export const FormYearDatePicker: FC<AppDatePickerProps> = ({ name = "", ...props }) => {
  const { control } = useFormContext();
  return (
    <FormFieldWrapper name={name}>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, ref, value } }) => {
          return (
            <AppYearDatePicker
              ref={ref}
              value={value ? dayjs(value, "YYYY") : null}
              onChange={(_, dateString) => {
                onChange(dateString);
                props.customOnChange?.();
              }}
              {...props}
            />
          );
        }}
      />
    </FormFieldWrapper>
  );
};
